import type { ComponentType, SVGProps } from 'react';

interface TableStateLayoutProps {
    icon: ComponentType<SVGProps<SVGSVGElement>>;
    title: string;
    text: string;
    actionLabel?: string;
    onAction?: () => void;
}

// Empty/error body for a DataTable: icon badge, title, one line of text, optional action.
export function TableStateLayout({
    icon: Icon,
    title,
    text,
    actionLabel,
    onAction
}: TableStateLayoutProps) {
    return (
        <div className="px-8 text-center">
            <div className="mx-auto mb-3 h-10 w-10 grid place-items-center rounded-full bg-white border border-gray-200 text-gray-400">
                <Icon className="h-[18px] w-[18px]" />
            </div>
            <h3 className="text-[13.5px] font-semibold text-gray-800">{title}</h3>
            <p className="mx-auto mt-1.5 max-w-xs text-[12.5px] leading-relaxed text-gray-500">
                {text}
            </p>
            {actionLabel && onAction && (
                <button
                    type="button"
                    onClick={onAction}
                    className="mt-4 inline-flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2 text-[13px] font-medium text-white hover:bg-gray-800 transition-colors duration-200"
                >
                    {actionLabel}
                </button>
            )}
        </div>
    );
}
